import {
  ADVERTISINGS_FETCH,
  ADVERTISINGS_ORDERBY,
  ADVERTISINGS_FILTER,
  ADVERTISINGS_PAGINATION,
  ADVERTISING_FETCH,
  NETWORK_START,
  NETWORK_ERROR,
  NETWORK_STOP,
  ADVERTISING_INSERT,
  ADVERTISING_UPDATE,
} from "../constants";
import {
  fetch_advertising,
  fetch_advertisings,
  insert_advertising,
  update_advertising,
} from "../../utils/requestHelper";

export function setAdvertisingsOrderBy(value) {
  return (dispatch) => {
    dispatch({ type: ADVERTISINGS_ORDERBY, value: value });
  };
}

export function setAdvertisingsFilter(value) {
  return (dispatch) => {
    dispatch({ type: ADVERTISINGS_FILTER, value: value });
  };
}

export function setAdvertisingsPagination(value) {
  return (dispatch) => {
    dispatch({ type: ADVERTISINGS_PAGINATION, value: value });
  };
}

export function fetchAdvertisings(filter, limit, skip, orderBy) {
  return async (dispatch) => {
    try {
      dispatch({ type: NETWORK_START });
      const result = await fetch_advertisings(filter, limit, skip, orderBy);
      if (result.success === true) {
        dispatch({
          type: ADVERTISINGS_FETCH,
          result: result.data,
          count: result.count,
        });
      }
      dispatch({ type: NETWORK_STOP });
    } catch (error) {
      dispatch({ type: NETWORK_STOP });
      dispatch({ type: NETWORK_ERROR, error });
    }
  };
}

export function fetchAdvertising(advertisingId) {
  return async (dispatch) => {
    try {
      dispatch({ type: NETWORK_START });
      const result = await fetch_advertising(advertisingId);
      if (result.success === true) {
        dispatch({ type: ADVERTISING_FETCH, result: result.data });
      }
      dispatch({ type: NETWORK_STOP });
    } catch (error) {
      dispatch({ type: NETWORK_STOP });
      dispatch({ type: NETWORK_ERROR, error });
    }
  };
}

export function updateAdvertising(advertisingId, data) {
  return async (dispatch) => {
    try {
      dispatch({ type: NETWORK_START });
      const result = await update_advertising(advertisingId, data);
      if (result.success === true) {
        dispatch({ type: ADVERTISING_UPDATE, result: result.data });
      }
      dispatch({ type: NETWORK_STOP });
    } catch (error) {
      dispatch({ type: NETWORK_STOP });
      dispatch({ type: NETWORK_ERROR, error });
    }
  };
}

export function insertAdvertising(data) {
  return async (dispatch) => {
    try {
      dispatch({ type: NETWORK_START });
      const result = await insert_advertising(data);
      if (result.success === true) {
        dispatch({ type: ADVERTISING_INSERT, result: result.data });
      }
      dispatch({ type: NETWORK_STOP });
    } catch (error) {
      dispatch({ type: NETWORK_STOP });
      dispatch({ type: NETWORK_ERROR, error });
    }
  };
}
